import { App } from 'vue'
import Card from './LpCard.vue'

// @ts-ignore
Card.install = (Vue: App) => {
  Vue.component(Card.name, Card)
}

export default Card
